<template>
    <div class="select">
        <el-dialog :title="activity_str + '活动商品设置'" :visible.sync="dialogVisible" width="1260px" :before-close="handleClose">
            <div class="main scroll-auto" v-loading="load">
                <el-tabs v-model="activeName">
                    <el-tab-pane label="商品设置" name="first">
                        <el-table ref="singleTable" :data="tableData" style="width: 100%" border>
                            <el-table-column prop="id" label="商品ID" width="80" align="center"> </el-table-column>
                            <el-table-column prop="tits" label="商品名称" width="180" align="center">
                                <template slot-scope="scope">
                                    <el-tooltip v-if="scope.row.tits && scope.row.tits.length > 8" :content="scope.row.tits" placement="top" effect="light">
                                        <span>{{ scope.row.tits | countFmt }}</span>
                                    </el-tooltip>
                                    <span v-else>{{ scope.row.tits | countFmt }}</span>
                                </template>
                            </el-table-column>
                            <el-table-column prop="goods_specifications_type_id" label="规格类型" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.goods_specifications_type_id == 1 ? "单规格" : "多规格" }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="sku_data[0].title" label="商品规格(sku)" align="center" width="180px">
                                <template slot-scope="scope">
                                    {{ scope.row.sku_data[0] ? scope.row.sku_data[0].title : "-" }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="price" label="销售价" align="center">
                                <template slot-scope="scope">
                                    <p>{{ scope.row.sku_data.length > 0 ? scope.row.sku_data[0].prices_mains : scope.row.prices_mains }}</p>
                                </template>
                            </el-table-column>
                            <el-table-column prop="merchandise_inventory" label="库存" align="center">
                                <template slot-scope="scope">
                                    {{ scope.row.goods_specifications_type_id == 1 ? scope.row.merchandise_inventory : scope.row.sku_data[0].merchandise_inventory }}
                                </template>
                            </el-table-column>
                            <el-table-column prop="retail_price" label="返现比例或现金" align="center" width="320px" v-if="activity_type == 'activity_share' || activity_type == 'activity_link'">
                                <template slot-scope="scope">
                                    <div class="price">
                                        <el-input
                                            v-model="scope.row.reward_share"
                                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                                            size="small"
                                            style="width: 120px"
                                            :disabled="scope.row.reward_share == '' && scope.row.reward_cash != ''"
                                        >
                                            <template slot="append">%</template>
                                        </el-input>
                                        或
                                        <el-input
                                            v-model="scope.row.reward_cash"
                                            oninput="value=value.replace(/[^\d.]/g, '').replace(/\.{2,}/g, '.').replace('.', '$#$').replace(/\./g, '').replace('$#$', '.').replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3').replace(/^\./g, '')"
                                            size="small"
                                            style="width: 120px"
                                            :disabled="scope.row.reward_share != '' && scope.row.reward_cash == ''"
                                        >
                                            <template slot="append">元</template>
                                        </el-input>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column prop="price" label="拼团价" align="center" width="140px" v-if="activity_type == 'activity_team'">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.price" size="small">
                                        <template slot="append">元</template>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="leader_price" label="团长价" align="center" width="140px" v-if="activity_type == 'activity_team' && is_open_leader_price == 1">
                                <template slot-scope="scope">
                                    <el-input v-model="scope.row.leader_price" size="small">
                                        <template slot="append">元</template>
                                    </el-input>
                                </template>
                            </el-table-column>
                            <el-table-column prop="repertory" label="活动库存" width="160" align="center">
                                <template slot-scope="scope">
                                    <el-input-number v-model="scope.row.total_stock" style="width: 120px" :min="0" :max="Number(scope.row.merchandise_inventory)"></el-input-number>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-tab-pane>
                    <el-tab-pane label="活动详情" name="second">
                        <GroupFormInfo ref="refGroupFormInfo" v-if="activity_type == 'activity_team'" :info="info"></GroupFormInfo>
                        <OrderCashbackFormInfo ref="refOrderCashbackFormInfo" v-else-if="activity_type == 'activity_share'" :info="info"></OrderCashbackFormInfo>
                        <SolitaireFormInfo ref="refSolitaireFormInfo" v-else-if="activity_type == 'activity_link'" :info="info"></SolitaireFormInfo>
                    </el-tab-pane>
                </el-tabs>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="handleClose" size="small">取 消</el-button>
                <el-button type="primary" size="small" @click="submit" :loading="btnLoad" v-if="activeName == 'first'">保 存</el-button>
                <el-button type="primary" size="small" @click="submit(true)" :loading="btnLoad" v-else>编辑商品</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import GroupFormInfo from "@/components/Modules/Application/Group/FormInfo.vue";
import OrderCashbackFormInfo from "@/components/Modules/Application/OrderCashback/FormInfo.vue";
import SolitaireFormInfo from "@/components/Modules/Application/Solitaire/FormInfo.vue";
export default {
    data() {
        return {
            load: false,
            btnLoad: false,
            activeName: "first",
            dialogVisible: false,
            form: {
                theme: "",
                secondary: "",
            },
            tableData: [],
            info: null,
            activity_type: "",
            activity_str: "",
            is_open_leader_price: 1, //是否开启团长价
            sellType: 1, //接龙购选填字段
        };
    },
    components: {
        GroupFormInfo,
        OrderCashbackFormInfo,
        SolitaireFormInfo,
    },
    filters: {
        dataFmt(val) {
            if (typeof val == "string") return val.replace(/\,/g, " / ");
            return val;
        },
        countFmt(val) {
            if (val) {
                if (val.length >= 8) {
                    return val.substring(0, 8) + "...";
                }
                return val;
            }
            return "-";
        },
    },
    computed: {
        ...mapGetters(["getToken"]),
    },
    methods: {
        ...mapActions({
            activityDetailList: "commodity/activityDetailList",
            editTeam: "activity/editTeam",
            editLink: "activity/editLink",
            editActivityShare: "activity/editActivityShare",
        }),
        submit(routeTo) {
            switch (this.activity_type) {
                // 拼团
                case "activity_team":
                    var { id, name, date, number, dd, hh, mm, on_line_group, is_open_leader_price, analog_group, activity_prepare, type, analog_group_number } = this.info;
                    if (dd == 30) {
                        hh = 0;
                        mm = 0;
                    }
                    var f = this.tableData.some((item) => {
                        return !item.price;
                    });
                    var l;
                    if (this.is_open_leader_price == 1) {
                        l = this.tableData.some((item) => {
                            return !item.leader_price;
                        });
                    }
                    var t = this.tableData.some((item) => {
                        return !item.total_stock;
                    });
                    if (f || t || l) {
                        return this.$message.warning("请填写金额(拼团价小于销售价，团长价小于拼团价)");
                    }
                    var activityProductData = [];
                    this.tableData.forEach((item) => {
                        let obj = {
                            spuId: item.id,
                            skuId: item.sku_data[0] ? item.sku_data[0].id : 0,
                            total_stock: item.total_stock,
                            price: Number(item.price),
                        };
                        if (is_open_leader_price == 1) {
                            obj.leader_price = Number(item.leader_price);
                        }
                        activityProductData.push(obj);
                    });
                    var params = {
                        id: id,
                        token: this.getToken,
                        name: name,
                        start_time: date ? date[0] : null,
                        end_time: date ? date[1] : null,
                        number: number,
                        task_time: dd * 24 * 60 * 60 + hh * 60 * 60 + mm * 60,
                        on_line_group: on_line_group,
                        is_open_leader_price: is_open_leader_price,
                        analog_group: analog_group,
                        activity_prepare: activity_prepare,
                        type: type,
                        activityProductData: activityProductData,
                        noProductEdit: 1,
                    };
                    if (analog_group == 1) {
                        params.analog_group_number = analog_group_number;
                    }
                    this.editTeam(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("提交成功！");
                            if (routeTo) {
                                this.$router.push("/home/marketing?type=" + this.activity_type);
                            }
                            this.handleClose();
                            this.$emit("initList");
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                    break;
                // 接龙
                case "activity_link":
                    var { id, name, explain, date, task_time, reward_share, reward_cash, purchases_type, buyLimit } = this.info;
                    var f = this.tableData.some((item) => {
                        return !item.reward_share && !item.reward_cash;
                    });
                    var l;
                    var t = this.tableData.some((item) => {
                        return !item.total_stock;
                    });
                    if (f || t || l) {
                        return this.$message.warning("请填写库存或返现金额!");
                    }
                    var activityProductData = [];
                    this.tableData.forEach((item) => {
                        let obj = {
                            spuId: item.id,
                            skuId: item.sku_data[0] ? item.sku_data[0].id : 0,
                            total_stock: item.total_stock,
                            reward_cash: item.reward_cash ? item.reward_cash : "",
                            reward_share: item.reward_share ? item.reward_share : "",
                        };
                        activityProductData.push(obj);
                    });
                    var params = {
                        id: id,
                        token: this.getToken,
                        name: name,
                        explain: explain,
                        startTime: date ? date[0] : null,
                        endTime: date ? date[1] : null,
                        task_time: task_time,
                        reward_share: reward_share,
                        reward_cash: reward_cash,
                        activityProductData: activityProductData,
                        noProductEdit: 1,
                    };
                    if (purchases_type == 2) {
                        params.buyLimit = buyLimit;
                    } else {
                        params.buyLimit = 0;
                    }
                    this.editLink(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("提交成功！");
                            if (routeTo) {
                                this.$router.push("/home/marketing?type=" + this.activity_type);
                            }
                            this.handleClose();
                            this.$emit("initList");
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                    break;
                // 返现
                case "activity_share":
                    var { id, name, date, rule_type, reward_share, reward_cash, limit_order_num } = this.info;
                    var f = this.tableData.some((item) => {
                        return !item.reward_share && !item.reward_cash;
                    });
                    var t = this.tableData.some((item) => {
                        return !item.total_stock;
                    });
                    if (f || t) {
                        return this.$message.warning("请填写库存或返现金额!");
                    }
                    var activityProductData = [];
                    this.tableData.forEach((item) => {
                        let obj = {
                            spuId: item.id,
                            skuId: item.sku_data[0] ? item.sku_data[0].id : 0,
                            total_stock: item.total_stock,
                            reward_cash: item.reward_cash ? item.reward_cash : "",
                            reward_share: item.reward_share ? item.reward_share : "",
                        };
                        activityProductData.push(obj);
                    });
                    var params = {
                        id: id,
                        token: this.getToken,
                        name: name,
                        start_time: date ? date[0] : null,
                        end_time: date ? date[1] : null,
                        rule_type: rule_type,
                        reward_share: reward_share,
                        reward_cash: reward_cash,
                        activityProductData: activityProductData,
                        noProductEdit: 1,
                    };
                    if (rule_type == 2) {
                        params.limit_order_num = limit_order_num;
                    }
                    this.editActivityShare(params).then(({ data }) => {
                        if (data.code == 1) {
                            this.$message.success("提交成功！");
                            if (routeTo) {
                                this.$router.push("/home/marketing?type=" + this.activity_type);
                            }
                            this.handleClose();
                            this.$emit("initList");
                        } else {
                            this.$message.error(data.msg);
                        }
                    });
                    break;
                default:
                    break;
            }
        },

        bindData(info, arr) {
            this.info = null;
            switch (this.activity_type) {
                // 拼团
                case "activity_team":
                    this.activity_str = "拼团";
                    var { id, name, start_time, end_time, number, task_time, on_line_group, is_open_leader_price, analog_group, activity_prepare, type, analog_group_number } = info;
                    this.is_open_leader_price = is_open_leader_price;
                    var dd, hh, mm;
                    dd = parseInt(task_time / 24 / 60 / 60);
                    hh = parseInt((task_time - dd * 24 * 60 * 60) / 60 / 60);
                    mm = parseInt(task_time - dd * 24 * 60 * 60 - hh * 60 * 60);
                    this.info = {
                        id: id,
                        name: name,
                        date: [start_time, end_time],
                        number: number,
                        dd: dd,
                        hh: hh,
                        mm: mm,
                        on_line_group: on_line_group,
                        is_open_leader_price: is_open_leader_price,
                        analog_group: analog_group,
                        activity_prepare: activity_prepare,
                        type: type,
                        analog_group_number: analog_group_number,
                        coupon_type: "1",
                    };
                    break;
                // 接龙
                case "activity_link":
                    this.activity_str = "接龙购";
                    var { id, name, start_time, end_time, reward_cash, reward_share, explain, task_time, buy_limit } = info;
                    let purchases_type = buy_limit == 0 ? "1" : "2";
                    var dd, hh, mm;
                    dd = parseInt(task_time / 24 / 60 / 60);
                    hh = parseInt((task_time - dd * 24 * 60 * 60) / 60 / 60);
                    mm = parseInt(task_time - dd * 24 * 60 * 60 - hh * 60 * 60);
                    this.info = {
                        id: id,
                        dd: dd,
                        hh: hh,
                        mm: mm,
                        name: name,
                        date: [start_time, end_time],
                        reward_share: Number(reward_share) == 0 ? "" : Number(reward_share),
                        reward_cash: Number(reward_cash) == 0 ? "" : Number(reward_cash),
                        explain: explain,
                        buyLimit: Number(buy_limit) == 0 ? "" : Number(buy_limit),
                        coupon_type: "1",
                        type: "1",
                        purchases_type: purchases_type,
                    };
                    break;
                // 返现
                case "activity_share":
                    this.activity_str = "订单返现";
                    var { id, name, start_time, end_time, reward_cash, reward_share, rule_type, limit_order_num } = info;
                    this.info = {
                        id: id,
                        name: name,
                        date: [start_time, end_time],
                        reward_share: Number(reward_share) == 0 ? "" : Number(reward_share),
                        reward_cash: Number(reward_cash) == 0 ? "" : Number(reward_cash),
                        rule_type: rule_type,
                        limit_order_num: limit_order_num,
                        type: "1",
                        coupon_type: "1",
                    };
                    break;
                default:
                    break;
            }
            this.load = true;
            let params = {
                token: this.getToken,
                product_list: arr,
            };
            this.activityDetailList(params).then((res) => {
                this.load = false;
                if (res.code == 1) {
                    this.tableData = res.data;
                    if (this.activity_type != "activity_team") {
                        let _arr = JSON.parse(JSON.stringify(this.tableData));
                        _arr.forEach((item, index) => {
                            item.reward_share = Number(info.reward_share) != 0 ? Number(info.reward_share) : "";
                            item.reward_cash = Number(info.reward_cash) != 0 ? Number(info.reward_cash) : "";
                        });
                        this.tableData = _arr;
                    }
                } else {
                    this.$message.error(res.msg);
                }
            });
        },
        handleClose() {
            this.activity_type = "";
            this.activeName = "first";
            this.dialogVisible = false;
        },
    },
};
</script>

<style lang="scss" scoped>
.el-form {
    padding: 40px 0;
}
::v-deep .el-dialog__body {
    padding: 0px 20px;
}
.main {
    height: 500px;
}
</style>